<template>
  <v-card class="pa-4">
    <h3 class="text-center">Customizar Etiqueta</h3>
    <p class="text-center">{{ $t('Layout da Etiqueta') }}:</p>
    <div class="d-flex" style="border-radius: 11px; border: 1px solid #0f3565">
      <v-btn
        class="ma-0 flex-grow-1"
        style="border-radius: 8px; max-width: 142px"
        :style="
          layout.usingIdentificationLayout
            ? 'background-color: #0f3565; color: white'
            : 'border:none'
        "
        :outlined="!layout.usingIdentificationLayout"
        @click="showIdentification"
      >
        <span style="font-size: 12px; text-transform: none">{{
          $t('Identificação')
        }}</span>
      </v-btn>
      <v-btn
        class="ma-0 flex-grow-1"
        style="border-radius: 8px"
        :dark="!layout.usingIdentificationLayout"
        :style="
          !layout.usingIdentificationLayout
            ? 'background-color: #0f3565; color: white !important`'
            : 'border:none'
        "
        :outlined="layout.usingIdentificationLayout"
        @click="showPropertyCode"
      >
        <span
          style="font-size: 12px; text-transform: none"
          :style="
            !layout.usingIdentificationLayout ? 'color: white !important`' : ''
          "
        >
          {{ $t('Patrimônio') }}
        </span>
      </v-btn>
    </div>
    <div v-if="layout.usingIdentificationLayout" class="mt-4">
      <v-switch
        v-model="layout.idLayout.showFullName"
        class="ml-1"
        hide-details=""
        inset
        :label="
          layout.idLayout.showFullName
            ? 'Identificação completa'
            : 'Identificação resumida'
        "
      ></v-switch>
    </div>
    <div class="d-flex justify-center">
      <v-file-input
        id="qr-code-image"
        block
        class="d-none"
        @change="changeQrCodeInstImage"
      ></v-file-input>

      <v-btn
        class="ma-1 mt-4 primary-button"
        text
        block
        v-if="!logo"
        @click="openChangeLogo"
      >
        {{ $t('Alterar logo') }}
      </v-btn>

      <v-btn
        class="ma-1 mt-4 primary-button"
        block
        text
        v-if="logo"
        @click="logo = null"
      >
        {{ $t('Usar imagem da instituição') }}
      </v-btn>
    </div>

    <!-- <v-card class="pa-4 mt-4" outlined>
      <div class="tag">
        <div class="d-flex justify-center align-center flex-column">
          <img
            class="mt-4 mb-2"
            :src="
              logo
                ? logo
                : institution && institution.logoPath
                ? institution.logoPath
                : require('../../../../assets/01_-_Reduzido_Cor.png')
            "
            alt="Equipacare"
            style="width: 6rem; border-radius: 8px"
          />
          <Qrcode :value="`${value}ABCD-EFGH`" :size="100"></Qrcode>
          <p class="pa-0 ma-0 text-center" style="font-size: 1.2rem">
            <strong v-if="layout.usingIdentificationLayout">{{
              formatIdText(`${value}ABCD-EFGH`)
            }}</strong>
            <strong v-else>PA-38945</strong>
          </p>
        </div>
      </div>
    </v-card> -->

    <v-card
      outlined
      class="pa-4 ma-2 text-center"
      height="100%"
      style="break-inside: avoid"
    >
      <img
        class="mt-4 mb-2"
        :src="
          logo
            ? logo
            : institution && institution.logoPath
            ? institution.logoPath
            : require('../../../../assets/01_-_Reduzido_Cor.png')
        "
        alt="Equipacare"
        style="width: 6rem; border-radius: 8px"
      />
      <Qrcode :value="`${value}ABCD-EFGH`" :size="100"></Qrcode>
      <strong class="text-center" style="font-size: 1.2rem">
        <span v-if="layout.usingIdentificationLayout">{{
          formatIdText(`${value}ABCD-EFGH`)
        }}</span>
        <span v-else>PA-38945</span>
      </strong>
    </v-card>

    <v-card-actions class="px-0">
      <v-btn outlined class="primary-button" @click="$emit('close')">
        Cancelar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        :loading="loading"
        class="ma-1 secondary-button"
        text
        @click="saveTagCustomization"
      >
        {{ $t('Salvar Etiqueta') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<style scoped>
.tag {
  display: flex;
  border: 1px solid black;
  margin: 5px;
  padding-top: 0;
  justify-content: center;
}

@media print {
  header {
    display: none;
  }

  .tag {
    max-width: 40% !important;
  }

  .row {
    margin-top: 5rem;
  }
}
</style>

<script>
import ApiService from '../../../../services/ApiService'
import Qrcode from 'qrcode.vue'

export default {
  name: 'CustomizeQR',

  components: {
    Qrcode,
  },

  created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))

    this.apiService
      .get(`institution/${this.institution.id}`)
      .then((response) => {
        this.institution = response.content
        
        if (this.institution.qrCodeTagCustomization) {
          const parsedLayout = JSON.parse(this.institution.qrCodeTagCustomization)
          this.layout = this.convertPascalToCamel(parsedLayout)
        }

        this.logo = this.layout.logo
      })
  },

  data: () => ({
    institution: {},
    value: '1234-',
    equipmentList: [],
    apiService: new ApiService(),
    logo: '',
    layout: {
      logo: '',
      usingIdentificationLayout: true,
      idLayout: {
        showFullName: true,
      },
    },
    headMenu: null,
    loading: false,
  }),

  methods: {
    convertPascalToCamel(obj) {
      if (obj === null || typeof obj !== 'object') return obj
      
      if (Array.isArray(obj)) {
        return obj.map(item => this.convertPascalToCamel(item))
      }
      
      const newObj = {}
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const camelKey = key.charAt(0).toLowerCase() + key.slice(1)
          newObj[camelKey] = this.convertPascalToCamel(obj[key])
        }
      }
      return newObj
    },

    openChangeLogo() {
      const input = document.getElementById('qr-code-image')
      input.click()
    },

    changeQrCodeInstImage(image) {
      try {
        const reader = new FileReader()
        reader.readAsDataURL(image)
        reader.onload = (readerEvt) => {
          this.logo = readerEvt.target.result
        }
        reader.onerror = () => this.$toast.error('Ocorreu um erro!')
      } catch (teste) {}
    },

    async saveTagCustomization() {
      this.layout.logo = this.logo
      const model = {
        customizationInJson: JSON.stringify(this.layout),
        institutionId: this.institution.id,
      }
      this.loading = true
      await this.apiService
        .post('institution/custom-qrcode-tag', model)
        .then((response) => {
          this.$toast.success(response.message)
          this.loading = false
          this.institution.qrCodeTagCustomization = JSON.stringify(this.layout)

          localStorage.removeItem('institution')
          localStorage.setItem('institution', JSON.stringify(this.institution))

          this.$emit('close')
        })
        .catch(() => {
          this.loading = false
        })
    },

    formatIdText(text) {
      if (this.layout.idLayout.showFullName) {
        return text
      }
      return text.split('-')[0]
    },

    showPropertyCode() {
      this.layout.usingIdentificationLayout = false
    },

    showIdentification() {
      this.layout.usingIdentificationLayout = true
    },
  },
}
</script>
